<template>
  <article-template class="mb-20 sm:mb-20" :document="articleEntryComputed">
    <template #content> </template>
    <template #sidebar>
      <!-- Unified Sidebar with Slider, CTA blocks, and Text blocks -->
      <article-sidebar
        :article="articleEntryComputed"
        portal-id="portal-djurfakta"
        slider-type="djurfakta"
      />
    </template>
  </article-template>
</template>

<script lang="ts" setup>
import type { Article } from '@/types/contentful'
import { handleArticleNotFound } from '@/utils/contentfulHelpers'

const { params } = useRouter().currentRoute.value
const { getArticles } = useContentful()

const slug = params.slug as string
const response = await useStatic(`djurfakta-${slug}`, async () => {
  return await getArticles({
    'fields.slug': slug,
    limit: 1,
    include: 10, // Include linked entries and assets
  })
})

if (!response.items.length) {
  handleArticleNotFound()
}

// Get the article entry from the response
const articleEntryComputed = computed(() => response.items[0] as Article)
</script>
